
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#484f5b","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/send-2"}},[_c('path',{attrs:{"d":"M7.4 6.317l8.49-2.83c3.81-1.27 5.88.81 4.62 4.62l-2.83 8.49c-1.9 5.71-5.02 5.71-6.92 0l-.84-2.52-2.52-.84c-5.71-1.897-5.71-5.007 0-6.92z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.11 13.65l3.58-3.59","opacity":".34"}})])])
          )
        }
      }
    